import { loadEnvConfig } from '../config';

const envConfig = loadEnvConfig();

export const baseURL = `https://bff.${envConfig.userWebapp.host}.${envConfig.domain}/`;
